import Resultados from "./Resultados";
export default Resultados;
